import api from './api'

export interface UpdateProfileRequest {
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  address?: string
  bio?: string
  dateOfBirth?: string
  emergencyContact?: string
  department?: string
}

export interface ChangePasswordRequest {
  currentPassword: string
  newPassword: string
}

export interface ProfileResponse {
  success: boolean
  message: string
  data: {
    id: string
    firstName: string
    lastName: string
    email: string
    phone?: string
    role: string
    college?: {
      id: string
      name: string
      code: string
    }
    isActive: boolean
    lastLogin?: string
    createdAt: string
    updatedAt: string
  }
}

export interface ApiResponse {
  success: boolean
  message: string
  data?: any
}

class AuthService {
  /**
   * Get current user profile
   */
  async getProfile(): Promise<ProfileResponse> {
    const response = await api.get('/auth/profile')
    return response.data
  }

  /**
   * Update current user profile
   */
  async updateProfile(updateData: UpdateProfileRequest): Promise<ProfileResponse> {
    const response = await api.patch('/auth/profile', updateData)
    return response.data
  }

  /**
   * Change user password
   */
  async changePassword(passwordData: ChangePasswordRequest): Promise<ApiResponse> {
    const response = await api.post('/auth/change-password', passwordData)
    return response.data
  }

  /**
   * Logout current user
   */
  async logout(): Promise<ApiResponse> {
    const response = await api.post('/auth/logout')
    // Clear tokens from both storage types
    localStorage.removeItem('token')
    sessionStorage.removeItem('token')
    return response.data
  }
}

export const authService = new AuthService()
export default authService
